import { protocolAiFooterHtml } from './protocol-footer';
import { formatTaskDeadline } from './task-deadline';

function wrapHtmlDocument(title: string, bodyHtml: string): string {
  return `<!DOCTYPE html>
<html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word"
      xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta charset="utf-8">
<title>${title}</title>
<style>
  body { font-family: 'Times New Roman', Times, serif; font-size: 12pt; line-height: 1.5; margin: 2cm; color: #111; }
  h1 { font-size: 18pt; text-align: center; margin-bottom: 12pt; }
  h2 { font-size: 14pt; margin-top: 18pt; margin-bottom: 8pt; border-bottom: 1px solid #ccc; padding-bottom: 4pt; }
  h3 { font-size: 12pt; margin-top: 12pt; }
  table { border-collapse: collapse; width: 100%; margin: 12pt 0; }
  th, td { border: 1px solid #333; padding: 6pt 8pt; text-align: left; vertical-align: top; }
  th { background: #f0f0f0; font-weight: bold; }
  ul, ol { margin: 8pt 0 8pt 20pt; }
  p { margin: 6pt 0; }
  .meta { color: #444; margin-bottom: 16pt; }
  .segment { margin-bottom: 10pt; }
  .segment-time { color: #666; font-size: 10pt; }
  .segment-speaker { font-weight: bold; }
  .ai-footer { margin-top: 24pt; padding-top: 12pt; border-top: 1px solid #ddd; text-align: center; font-size: 9pt; color: #888; font-style: italic; }
</style>
</head>
<body>
${bodyHtml}
${protocolAiFooterHtml()}
</body>
</html>`;
}

export function downloadAsDoc(filename: string, title: string, bodyHtml: string): void {
  const html = wrapHtmlDocument(title, bodyHtml);
  const blob = new Blob(['\ufeff', html], { type: 'application/msword;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.doc') ? filename : `${filename}.doc`;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadAsMarkdown(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.md') ? filename : `${filename}.md`;
  a.click();
  URL.revokeObjectURL(url);
}

export function segmentsToHtml(
  segments: { start_time: string; speaker: string; text: string }[],
): string {
  return segments
    .map(
      s => `<div class="segment">
        <span class="segment-time">[${s.start_time}]</span>
        <span class="segment-speaker">${s.speaker}:</span>
        ${s.text.replace(/</g, '&lt;')}
      </div>`,
    )
    .join('\n');
}

export function tasksToHtml(
  tasks: { task: string; assignee: string; deadline: string; priority: string }[],
): string {
  if (!tasks.length) {
    return '<p>Поручения не найдены.</p>';
  }
  const rows = tasks
    .map(
      (t, i) => `<tr>
        <td>${i + 1}</td>
        <td>${t.task.replace(/</g, '&lt;')}</td>
        <td>${(t.assignee || '—').replace(/</g, '&lt;')}</td>
        <td>${formatTaskDeadline(t.deadline).replace(/</g, '&lt;')}</td>
        <td>${(t.priority || 'Средний').replace(/</g, '&lt;')}</td>
      </tr>`,
    )
    .join('\n');
  return `<h2>Задачи и поручения</h2>
<table>
  <thead><tr><th>№</th><th>Задача</th><th>Ответственный</th><th>Срок</th><th>Приоритет</th></tr></thead>
  <tbody>${rows}</tbody>
</table>`;
}

export function summaryToHtml(summary: string): string {
  const lines = summary.split('\n');
  return lines
    .map(line => {
      const t = line.trim();
      if (!t) return '';
      if (t.startsWith('•') || t.startsWith('-')) {
        return `<li>${t.replace(/^[•-]\s*/, '')}</li>`;
      }
      if (t.startsWith('**') && t.endsWith('**')) {
        return `<h3>${t.replace(/\*\*/g, '')}</h3>`;
      }
      return `<p>${t}</p>`;
    })
    .join('\n');
}
